import { Controller } from '@hotwired/stimulus';

export default class AdminBoardsController extends Controller {
  static targets = [
    'faculty',
    'subjectCourse'
  ];

  connect() {
    this.toggleSubjectCourse();
  }

  toggleFaculty() {
    const {checked} = this.facultyTarget;

    for (const subjectCourse of this.subjectCourseTargets) {
      subjectCourse.checked = checked;
    }
  }

  toggleSubjectCourse() {
    const {subjectCourseTargets, facultyTarget} = this;

    if (subjectCourseTargets.every(subjectCourse => subjectCourse.checked)) {
      facultyTarget.checked       = true;
      facultyTarget.indeterminate = false;
    } else if (subjectCourseTargets.every(subjectCourse => !subjectCourse.checked)) {
      facultyTarget.checked       = false;
      facultyTarget.indeterminate = false;
    } else {
      facultyTarget.checked       = true;
      facultyTarget.indeterminate = true;
    }
  }
}
